
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class AccountTypeCard extends Vue {
  @Prop({ type: String, default: '' })
  private readonly title!: string

  @Prop({ type: String, default: '' })
  private readonly text!: string

  @Prop({ type: Boolean, default: false })
  private readonly value!: boolean

  get selected (): boolean {
    return this.value
  }

  set selected (value: boolean) {
    this.$emit('input', value)
  }

  select () {
    this.selected = !this.selected
  }
}
